import { FunctionComponent } from 'react';
import { BadgeContainer, PHASE_STYLES, PhaseLabel } from './styled';

interface Props {
    phase: 'product' | 'technical';
}

/**
 * Sub-badge rendered next to ``<ClarityBadge>`` showing which planning
 * phase the current question batch belongs to. Batches are
 * phase-uniform server-side (see ``beehive-backend/src/jobs/planning.py``),
 * so the caller just reads ``questions[0].questionPhase``.
 */
const PhaseBadge: FunctionComponent<Props> = ({ phase }) => {
    const style = PHASE_STYLES[phase];
    if (!style) return null;

    return (
        <BadgeContainer themeColor={style.color} themeBg={style.bg}>
            <PhaseLabel themeColor={style.color} themeBg={style.bg}>
                Phase: {style.label}
            </PhaseLabel>
        </BadgeContainer>
    );
};

export default PhaseBadge;
